export default __webpack_public_path__ + "static/media/Supplier_Product_Promotion_1311_2611_2025.d3be3bc7.xlsx";